import React from 'react';
import moment from 'moment';
import { notify } from 'react-notify-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChild, faPause, faPlay } from '@fortawesome/free-solid-svg-icons';

/**
 * @param {string} oldDate ISO date string of the last pause event
 * @returns {string} Human readable elapsed time in Spanish
 */
export function calculateElapsedTime(oldDate) {
  try {
    const currentDate = moment();
    const oldDateMoment = moment(oldDate);
    const diffInMilliseconds = currentDate.diff(oldDateMoment);
    const duration = moment.duration(diffInMilliseconds);
    const monthOrMonths = oldDateMoment.month() === 0 ? 'mes' : 'mese';
    const unitOfTime = ['año', monthOrMonths, 'día', 'hora'];
    const valuesOfTime = [
      duration.years(),
      duration.months(),
      duration.days(),
      duration.hours(),
    ];
    let message = '';
    unitOfTime.forEach((unid, index) => {
      if (valuesOfTime[index] > 0) {
        message += `${valuesOfTime[index]} ${unid}${valuesOfTime[index] > 1 ? 's' : ''
          } `;
      }
    });
    return message.trim() === '' ? 'Recién ocurrió' : message;
  } catch (error) {
    notify.show(
      'Ha ocurrido un error al mostrar la fecha de pausado del estudiante.',
      'error'
    );
    return '';
  }
}

function getInitials(fullName) {
  const cleanName = (fullName || '').trim();
  if (!cleanName) return 'RS';
  const parts = cleanName.split(/\s+/).filter(Boolean);
  const firstInitial = parts[0] ? parts[0][0] : 'R';
  const secondInitial = parts[1] ? parts[1][0] : '';
  return `${firstInitial}${secondInitial}`.toUpperCase();
}

export default function StudentName({
  name = 'Error',
  statusStudent,
  dateOfTheLastPause,
  isRollingKid,
  fatherName,
  fatherLastName,
}) {
  const displayName = name || 'Error';
  const isPaused = Boolean(statusStudent);
  const showFather = Boolean(isRollingKid && fatherName && fatherLastName);

  return (
    <div className="sd-card sd-identity w-100">
      <div className="sd-eyebrow">Ficha del estudiante</div>
      <div className="sd-identity-top">
        <div className="sd-avatar" aria-hidden="true">
          {getInitials(displayName)}
        </div>
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <h2 className="sd-identity-name" title={displayName}>
            {displayName}
          </h2>
          <p className="sd-identity-sub">
            {isRollingKid && 'Rolling Kids'}
          </p>
        </div>
      </div>
      <div className="sd-badge-row">
        <span
          className={`sd-pill ${isPaused ? 'sd-pill-paused' : 'sd-pill-active'}`}
        >
          <FontAwesomeIcon icon={isPaused ? faPause : faPlay} size="xs" />
          {isPaused ? 'Pausado' : 'Activo'}
        </span>
        {isRollingKid && (
          <span className="sd-pill sd-pill-kid">
            <FontAwesomeIcon icon={faChild} size="xs" />
            Rolling Kid
          </span>
        )}
      </div>
      {isPaused && dateOfTheLastPause && (
        <div className="sd-pause-meta">
          <div>
            Pausado el{' '}
            <strong>{moment(dateOfTheLastPause).format('DD/MM/YYYY')}</strong>
          </div>
          <div>
            Hace <strong>{calculateElapsedTime(dateOfTheLastPause)}</strong>
          </div>
        </div>
      )}
      {showFather && (
        <div className="sd-field" style={{ borderBottom: 0, paddingBottom: 0 }}>
          <span className="sd-label">Tutor</span>
          <span className="sd-value">
            {fatherName} {fatherLastName}
          </span>
        </div>
      )}
    </div>
  );
}
